const ActionTypes = {
    CREATE_ENTRY: 'CREATE_ENTRY',
    GET_ENTRIES : 'GET_ENTRIES',

    SHOW_HELP : 'SHOW_HELP',

    GET_LEAGUE : 'GET_LEAGUE',
    REFRESH_LEAGUE : 'REFRESH_LEAGUE',
    GET_LEAGUES : 'GET_LEAGUES',
    PAGINATE_LEAGUES : 'PAGINATE_LEAGUES',
    REFRESH_LEAGUE : 'REFRESH_LEAGUE',

    GET_MATCH : 'GET_MATCH',
    REFRESH_MATCH : 'REFRESH_MATCH',
    GET_MATCHES : 'GET_MATCHES',


    GET_REWARD : 'GET_REWARD',
    UPDATE_REWARD_CLAIM : 'UPDATE_REWARD_CLAIM',


    GET_NOTIFICATIONS : 'GET_NOTIFICATIONS',
    GET_NOTIFICATION : 'GET_NOTIFICATION',
    PAGINATE_NOTIFICATIONS : 'PAGINATE_NOTIFICATIONS',
    REFRESH_NOTIFICATIONS : 'REFRESH_NOTIFICATIONS',
    GET_UNSEEN_COUNT : 'GET_UNSEEN_COUNT',
    UPDATE_SEEN : 'UPDATE_SEEN',

    GET_PLAYERS : 'GET_PLAYERS',
    UPDATE_PLAYERS: 'UPDATE_PLAYERS',
    UPDATE_PLAYER :'UPDATE_PLAYER',

    SHARE_FB :'SHARE_FB',

    SAVE_USER : 'SAVE_USER',
    SAVE_USER_FULFILLED : 'SAVE_USER_FULFILLED',
    RETRIEVE_USER_PENDING :"RETRIEVE_USER_PENDING",
    RETRIEVE_USER_FULFILLED : 'RETRIEVE_USER_FULFILLED',
    RETRIEVE_USER_REJECTED : 'RETRIEVE_USER_REJECTED',

    GET_TRANSACTIONS : 'GET_TRANSACTIONS',

    GET_USER : 'GET_USER',
    GET_OR_CREATE_USER : 'GET_OR_CREATE_USER',
    SIGN_UP_USER : 'SIGN_UP_USER',
    SIGN_OUT_USER : 'SIGN_OUT_USER',
    ANONYMOUS_USER_IN : 'ANONYMOUS_USER_IN',
    UPDATE_SHOW_HELP : 'UPDATE_SHOW_HELP',
    UPDATE_PHONE_NUMBER: 'UPDATE_PHONE_NUMBER',
    UPDATE_INVITED_BY : 'UPDATE_INVITED_BY',
    UPDATE_SETTINGS : 'UPDATE_SETTINGS',
    UPDATE_USER : 'UPDATE_USER',
    SAVE_FAILED_CREDENTIALS:'SAVE_FAILED_CREDENTIALS',
    EDITION_CHANGED : 'EDITION_CHANGED',
    FB_USER_NOT_FOUND : 'FB_USER_NOT_FOUND',

    HOME : 'HOME',
    LEAGUES : 'LEAGUES',
    BACK : 'BACK',



    OPEN_MODAL : 'OPEN_MODAL',
    OPEN_LAST_OPEN_MODAL : 'OPEN_LAST_OPEN_MODAL',
    CLOSE_MODAL : "CLOSE_MODAL",
    PRE_CLOSE_MODAL : "PRE_CLOSE_MODAL",

    ADD_TO_CACHE : 'ADD_TO_CACHE',
    REMOVE_FROM_CACHE : 'REMOVE_FROM_CACHE',

    SHOW_ALERT: 'SHOW_ALERT',
    HIDE_ALERT: 'HIDE_ALERT',

    DIMENSION_CHANGED: 'DIMENSION_CHANGED',

    GET_LBS : 'GET_LBS',
    GET_LB_STATUS : 'GET_LB_STATUS',

    GET_SPONSORS : 'GET_SPONSORS',


    getCCFulfilled : (action) =>(action+'_CC_FULFILLED'),
    getFulfilled : (action) =>(action+'_FULFILLED'),
    getRejected : (action) =>(action+'_REJECTED'),
    getPending : (action) => (action + '_PENDING')

};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/app/data/actions/types/ActionTypes.js